import { REQUIRED_ROLES } from "./rquired-roles";

export const initialEvaluationRoutes = {
  path: "/evaluation",
  name: "InitialEvaluation",
  meta: {
    authorized: true,
    roles: REQUIRED_ROLES['initial-evaluation']
  },
  component: () => import("@/views/initial-evaluation/index.vue"),
  children: [
    {
      path: "",
      name: "InitialEvaluationList",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['initial-evaluation']
      },
      component: () => import("@/views/initial-evaluation/list/index.vue"),
    },
    {
      path: "add",
      name: "InitialEvaluationAdd",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['initial-evaluation']
      },
      component: () =>
        import("@/views/initial-evaluation/AddEditForm/index.vue"),
    },
    {
      path: "details/:id",
      name: "InitialEvaluationDetails",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['initial-evaluation']
      },
      component: () => import("@/views/initial-evaluation/details/index.vue"),
    },
    {
      path: "edit/:id",
      name: "InitialEvaluationEdit",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES['initial-evaluation']
      },
      component: () =>
        import("@/views/initial-evaluation/AddEditForm/index.vue"),
    },
  ],
};
